<div class="list-page-container">
  <div>
    <h1 class="page-header">{{ "APP.EVENTS.LIST_HEADER" | translate }}</h1>

    <hr class="hr" />
  </div>

  <app-event-list></app-event-list>
</div>
